"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatePatch = void 0;
class TemplatePatch {
    constructor() {
    }
    static getAttributeTypeMap() {
        return TemplatePatch.attributeTypeMap;
    }
}
exports.TemplatePatch = TemplatePatch;
TemplatePatch.discriminator = undefined;
TemplatePatch.attributeTypeMap = [
    {
        "name": "description",
        "baseName": "description",
        "type": "string",
        "format": ""
    },
    {
        "name": "featureFlag",
        "baseName": "featureFlag",
        "type": "string",
        "format": ""
    },
    {
        "name": "filterTypes",
        "baseName": "filterTypes",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "instructions",
        "baseName": "instructions",
        "type": "string",
        "format": ""
    },
    {
        "name": "instructionsLink",
        "baseName": "instructionsLink",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "kind",
        "baseName": "kind",
        "type": "TransformationTemplateKind",
        "format": ""
    },
    {
        "name": "logo",
        "baseName": "logo",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    },
    {
        "name": "transformation",
        "baseName": "transformation",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=TemplatePatch.js.map